
/* ==========================================================================


  Custom handlers

  A location for small custom links, components, items that don't warrant their own components folders / files
  eg: Feedback link. This is one custom handler with one trigger function.

========================================================================== */

/*global OOo */
/*jshint camelcase: false*/
/*jscs:disable requireCamelCaseOrUpperCaseIdentifiers */

'use strict';

import $ from 'jquery';
import utilities from '../../js/utilities';

export default class CustomHandlers {

  static initialize($el) {
    $el.find('.js-feedback').each(function(i, elem) {
      CustomHandlers._feedBackButtonHandler($(elem));
    });

    // Add more small componenets with DOM existence checks here..

  }

  /*
    Trigger click on third party feedback link when in page feed back link is clicked
  */
  static _feedBackButtonHandler($link) {

    //Target will be the third party link from Opinion lab.
    //this may or may not be in the site as it is a third party script loaded in via gtm.
    utilities.waitForElement('a[id*=oo_tab_]', function() {
      $link.on('click', function(e) {

        //This OOo object is the Opinion lab CLass and it will contain the show method that they
        // use internally. So this click handler fires their internal show method if it exists.
        if (typeof OOo !== 'undefined') {
          OOo.oo_feedback.show(e);
        }

      });
    });
  }
}

export function create($parent) {
  CustomHandlers.initialize($parent);
}



// WEBPACK FOOTER //
// ./assets/components/CustomHandlers/CustomHandlers.js